<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'

const announcement = ref('')
const priority = ref('polite')

const handleAnnouncement = (event) => {
  announcement.value = event.detail.message
  priority.value = event.detail.priority || 'polite'
}

onMounted(() => {
  window.addEventListener('scribe11-announce', handleAnnouncement)
  window.announceToScreenReader = (message, p = 'polite') => {
    window.dispatchEvent(new CustomEvent('scribe11-announce', { detail: { message, priority: p } }))
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('scribe11-announce', handleAnnouncement)
  window.announceToScreenReader = null
})
</script>

<template>
  <div
    class="sr-only"
    :aria-live="priority"
    aria-atomic="true"
  >
    {{ announcement }}
  </div>
</template>
